import { GuardedComponent } from '../components/guarded-component';
import { ScheduleDragAndDrop } from '../features/schedule-drag-and-drop/schedule-drag-and-drop';
import { BulkSchedulingPage } from '../features/scheduling/bulk-scheduling.page';
import { UserPermissionName } from '../models/user-permission-name';

export const SchedulingDragAndDropRoute = {
  path: '/schedule-balancing',
  element: (
    <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SCHEDULEBALANCING]} showPermissionError>
      <ScheduleDragAndDrop />
    </GuardedComponent>
  ),
};
